import { render, staticRenderFns } from "./MallCreate.vue?vue&type=template&id=6f647164&"
import script from "./MallCreate.vue?vue&type=script&lang=ts&"
export * from "./MallCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports